module.exports = __webpack_public_path__ + "static/media/telegramIcon.738d4d42.png";